import React, { useContext, useEffect, useState } from 'react';
import CheckedTable from './CheckedTable';
import CDBConferenceContext from '../../../../../contexts/app';
import { DeliveryRoll } from '../../../../../types/business';
import { DeliveryRollsContext } from '..';

const Checked: React.FC = () => {
  const context = useContext(CDBConferenceContext);
  const { searchValue } = useContext(DeliveryRollsContext);

  const [deliveryRolls, setDeliveryRolls] = useState<DeliveryRoll[]>([]);

  function filterDeliveryRolls(deliveryRoll: DeliveryRoll): boolean {
    const { number, romaneios } = deliveryRoll;
    return (
      number.toString().includes(searchValue) ||
      romaneios.some((ro) =>
        ro.name.toLowerCase().includes(searchValue.toLowerCase())
      )
    );
  }

  useEffect(() => {
    setDeliveryRolls(context.computed.checked);
  }, [context.computed]);

  return (
    <CheckedTable deliveryRolls={deliveryRolls.filter(filterDeliveryRolls)} />
  );
};

export default Checked;
